import React from 'react';

const SparklingGold = ({ density = 'medium' }) => {
  // Anzahl der Partikel basierend auf density
  const particleCount = density === 'high' ? 30 : density === 'low' ? 10 : 20;
  
  // Generiere zufällige Partikel-Positionen und Animationen
  const particles = Array.from({ length: particleCount }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: `${Math.random() * 3}s`,
    duration: `${2 + Math.random() * 2}s`,
    size: Math.random() > 0.5 ? 'small' : 'large'
  }));

  return (
    <div className="sparkling-container absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className={`sparkle ${particle.size}`}
          style={{
            left: particle.left,
            top: particle.top,
            animationDelay: particle.delay,
            animationDuration: particle.duration
          }}
        />
      ))}
    </div>
  );
};

export default SparklingGold;
